import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 389px;
  padding: 32px;
  border-radius: 16px;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const IconWrapper = styled.div<{ $usesCurrentColor?: boolean }>`
  display: flex;
  width: 32px;
  height: 32px;
  color: ${({ $usesCurrentColor, theme }) =>
    $usesCurrentColor ? theme.color.darkGrey : 'inherit'};

  & > svg {
    width: 32px;
    height: 32px;
  }
`

export const Chip = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 6px;
  border-radius: 16px;
  background: ${({ theme }) => theme.color.lightGreen};
  color: ${({ theme }) => theme.color.darkGreen};
  font-family: 'Segoe UI';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  white-space: nowrap;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`

export const Title = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
`

export const Description = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`

export const Checks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
`

export const CheckItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 12px;
  width: 100%;
`

export const CheckIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.color.brandGreen};
`

export const CheckText = styled.span`
  flex: 1;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  margin-top: auto;
`

export const Footnote = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  text-align: center;
`

export const StyledGreyTextButton = styled(GreyTextButton)`
  width: 100%;
`
